import { render, staticRenderFns } from "./EditorMenu.vue?vue&type=template&id=cd90ec98&scoped=true&"
import script from "./EditorMenu.vue?vue&type=script&lang=js&"
export * from "./EditorMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditorMenu.vue?vue&type=style&index=0&id=cd90ec98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd90ec98",
  null
  
)

export default component.exports